if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      abortController = undefined;
      onVariantChangeUnsubscriber = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      cartUpdateUnsubscriber = undefined;

      constructor() {
        super();
        this.additionalProductFound = this.getAttribute("data-merge-product")
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get productId() {
        return this.getAttribute('data-product-id');
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();
        this.base64Image = null;

        this.onVariantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();

        this.currentVariant = this.getSelectedVariant(this);
        if (this.currentVariant) {
          this.updateMedia(this.currentVariant);

        }

        const optionValues = [];
        this.currentVariant.options.forEach(element => {
          const input = this.querySelector(`input[value="${element}"]`);
          if (input) {
            optionValues.push(input.getAttribute("data-option-value-id"));
          }
        });

        if (optionValues.length > 0) {
          setTimeout(() => {
            this.updateVariantImage(optionValues);
          }, 0);
        }

        // this.selectedInputs = this.querySelectorAll(`input[type="radio"]:selected`);
        // option recommendation 
        this.updateRecommendationOption();
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.disableButtons();
        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
        const viewMode = this.dataset.viewMode || 'main-product';

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage, viewMode, selectedOptionValues)
            : this.handleUpdateProductInfo(productUrl, viewMode, selectedOptionValues, event.target),
        });

        this.updateVariantImage(selectedOptionValues);
      }

      async handleSwapProduct(productUrl, updateFullPage, viewMode, selectedOptionValues) {
        return (html) => {
          const quickView = html.querySelector('#MainProduct-quick-view__content');
          if (quickView && viewMode === 'quick-view') {
            html = quickView.content.cloneNode(true);
          }
          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));

          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
            HTMLUpdateUtility.viewTransition(
              document.getElementById('shopify-section-sticky-atc-bar'),
              html.getElementById('shopify-section-sticky-atc-bar'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );

            if (!variant) {
              this.setUnavailable();
              return;
            }
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }

          this.currentVariant = variant;
        };
      }


      async checkForRelatedProducts(selectedOptionValues) {

        const relatedProductsOptions = this.querySelectorAll(".product-options-with-values");
        if (relatedProductsOptions.length == 0) {
          return false;
        }

        // Build selected values array
        const optValue = [];
        selectedOptionValues.forEach(element => {
          const input = this.querySelector(`input[type="radio"][data-option-value-id="${element}"]`);
          if (input && input.value) {
            optValue.push({
              name: input.getAttribute("data-option-name"),
              value: input.value
            });
          }
        });

        // Parse JSON from <script> tags
        const relatedOptions = {};
        relatedProductsOptions.forEach((scriptEl) => {
          const handle = scriptEl.id;
          const data = JSON.parse(scriptEl.textContent.trim());
          relatedOptions[handle] = data;
        });

        const productOptionMapping = [];

        // Match against each related product
        for (const handle in relatedOptions) {
          const product = relatedOptions[handle];
          let matchesAll = true;

          // NEW: store matched optionValueIds for this product
          const matchedValueIds = [];

          for (const selected of optValue) {
            const optionName = selected.name;
            const optionValue = selected.value;

            if (!product[optionName]) {
              matchesAll = false;
              break;
            }

            const valuesObj = product[product[optionName]];

            // No matching value = fail
            if (!valuesObj || !valuesObj[optionValue]) {
              matchesAll = false;
              break;
            }

            // NEW: store the matching id
            matchedValueIds.push(valuesObj[optionValue]);
          }

          if (matchesAll) {
            productOptionMapping.push({
              handle: handle,
              values: matchedValueIds
            });
          }
        }

        if (productOptionMapping.length > 0) {
          return productOptionMapping
        }
        return false;
      }


      getImageUrlById(id) {
        const el = document.querySelector(`[data-option-value-id="${id}"]`);
        return el ? el.getAttribute("data-image-url") : null;
      }

      // async updateBuyButtons(productHandle, selectedOptionValues, oldSelectedOptionValues) {
      //   // 1. Build the request URL
      //   const requestUrl = this.buildRequestUrlWithParams(`/products/${productHandle}`, selectedOptionValues, false);
      //   console.log("requestUrl:", requestUrl);

      //   // 2. Fetch the HTML from the product page
      //   const response = await fetch(requestUrl, {
      //     method: "GET",
      //     headers: {
      //       "X-Requested-With": "XMLHttpRequest"
      //     }
      //   });

      //   const htmlText = await response.text();

      //   // Parse returned HTML
      //   const parser = new DOMParser();
      //   const doc = parser.parseFromString(htmlText, "text/html");

      //   // List of blocks we want to replace
      //   const blocksToReplace = [
      //     ".product__block.product__block--buy_buttons",
      //     ".product__block.product__block--price",
      //     ".product__block.product__block--sku",
      //     ".product__block.product__block--inventory",
      //   ];

      //   // Loop through each block selector
      //   blocksToReplace.forEach(async (selector) => {
      //     let newBlock = doc.querySelector(selector);
      //     const currentBlock = document.querySelector(selector);

      //     if (!newBlock || !currentBlock) {
      //       console.warn(`Block not found for selector: ${selector}`);
      //       return;
      //     }
      //     if(selector == ".product__block.product__block--buy_buttons" && newBlock.querySelector(`input[name="id"]`) && newBlock.querySelector(`input[name="id"]`).value == ""){
      //       newBlock = `<div class="product-form">
      //         <div class="product-form__buttons form">
      //           <button type="submit" name="add" class="product-form__submit button button--full-width button--primary" disabled="">
      //             Sold out
      //           </button>
      //         </div>
      //       </div>`
      //       currentBlock.innerHTML = newBlock;
      //     }else{

      //       currentBlock.replaceWith(newBlock);
      //     }

      //   });

      //   console.log("All product blocks updated!");

      // }

      async updateAddToCartButton(html){

        const blocksToReplace = [
          ".product__block.product__block--buy_buttons",
          ".product__block.product__block--price",
          ".product__block.product__block--sku",
          ".product__block.product__block--inventory",
        ];

        blocksToReplace.forEach(selector => {
          const newAddToCartBlock = html.querySelector(selector);
          const oldAddToCartBlock = document.querySelector(selector);

          if(!newAddToCartBlock || !oldAddToCartBlock) return;
          oldAddToCartBlock.innerHTML = newAddToCartBlock.innerHTML;
          
        });

        if(document.querySelector('sticky-atc-bar') && document.querySelector('product-info')){
          document.querySelector('sticky-atc-bar').productForm.innerHTML = document.querySelector('product-info').productForm.innerHTML;
        }
         
      }

      async updateBuyButtons(productsArray, currentTarget) {
        // Build all URLs for parallel calls
        const variantSelect = this.querySelector("variant-selects");
        const urls = productsArray.map((p) => {
          return this.buildRequestUrlWithParams(`/products/${p.handle}`, p.values, false);
        });

        // Run parallel requests
        const responses = await Promise.all(
          urls.map((url) =>
            fetch(url, {
              method: "GET",
              headers: { "X-Requested-With": "XMLHttpRequest" }
            }).then((r) => r.text())
          )
        );

        // Parse all HTML docs
        const docs = responses.map((html) => new DOMParser().parseFromString(html, "text/html"));

        // Try to find ANY variant ID from any response
        let foundVariantId = "";
        let foundVariantHandle = "";
        let winningDoc = null;
        let isIdFound = false;
        let unavailableOptsValue = {};
        const totalDocs = docs.length;

        for (let doc of docs) {
          // Udpate variant ID
          const variantInput = doc.querySelector('.product__block--buy_buttons input[name="id"]');
          if (variantInput && variantInput.value && !isIdFound) {
            let isIdFound = true;
            foundVariantId = variantInput.value;
            winningDoc = doc;
          }

          const productHandleInput = doc.querySelector('.product__info-container');
          if (productHandleInput ) {
            foundVariantHandle = productHandleInput.dataset.url ;
          }

          // Update available options
          const unavailableOpts = doc.querySelectorAll("variant-selects input.disabled");
          // console.log("una: ", doc.querySelectorAll("variant-selects"));
          unavailableOpts.forEach(opt => {
            const optvalue = opt.value;
            if (unavailableOptsValue[optvalue]) {
              unavailableOpts[optvalue] += 1;
            } else {
              unavailableOpts[optvalue] = 1
            }
          });
        }

        for (const key in unavailableOptsValue) {
          if (unavailableOptsValue[key] >= totalDocs) {
            const input = variantSelect.querySelector(`input[value="${key}]`);
            if (input) input.classList.add("disabled");
          }
        }



        if (foundVariantId && foundVariantHandle) {
          this.updateURL(foundVariantHandle, foundVariantId);
            const cleanHandle = foundVariantHandle
              .replace('/products/', '');
            const sections = ['sticky-atc-bar'];
            const url = `/products/${cleanHandle}?variant=${foundVariantId}&sections=${sections.join(',')}`;
            fetch(url, {
              headers: {
                'X-Requested-With': 'XMLHttpRequest'
              }
            })
            .then(res => res.json())
            .then(data => {
              const sectionHTML = data['sticky-atc-bar'];
              if (!sectionHTML) return;

              const parser = new DOMParser();
              const doc = parser.parseFromString(sectionHTML, 'text/html');

              const mlvStickyOldAddToCart =
                document.querySelector('#product-form-sticky-atc-bar');

              const mlvStickyNewAddToCart = doc.querySelector('#product-form-sticky-atc-bar');
              if (mlvStickyOldAddToCart && mlvStickyNewAddToCart) {
                mlvStickyOldAddToCart.replaceWith(mlvStickyNewAddToCart);
              }
            })
            .catch(err => {
              console.error('Section fetch error:', err);
            });
        }

        // List of blocks we want to replace
        const blocksToReplace = [
          ".product__block.product__block--buy_buttons",
          ".product__block.product__block--price",
          ".product__block.product__block--sku",
          ".product__block.product__block--inventory",
          ".product__block--metafield_collapsible_tab",
        ];

        // added sticky-atc-bar by mlveda

        // If no matching variant found — render SOLD OUT
        const stickyAtcBar = document.getElementById(`shopify-section-sticky-atc-bar`);

        if (!foundVariantId || !winningDoc) {
          blocksToReplace.forEach((selector) => {
            const currentBlock = document.querySelector(selector);
            if (!currentBlock) return;

            if (selector === ".product__block.product__block--buy_buttons") {
              currentBlock.innerHTML = `
                <div class="product-form">
                  <div class="product-form__buttons form">
                    <button type="submit" name="add"
                      class="product-form__submit button button--full-width button--primary"
                      disabled>
                      Unavailable
                    </button>
                  </div>
                </div>
              `;
            } else {
              currentBlock.innerHTML = ""; // Clear other sections or keep as is
            }
          });

          console.log("No variant found — rendered SOLD OUT");
          // this.findNextAvailableVariant(currentTarget)
          if (stickyAtcBar) {
            stickyAtcBar.classList.add('hidden');
          }
          return;
        }else{
          if (stickyAtcBar) {
            stickyAtcBar.classList.remove('hidden');
          }
        } 

        // Replace blocks using winningDoc
        blocksToReplace.forEach((selector) => {
          const newBlock = winningDoc.querySelector(selector);
          const currentBlock = document.querySelector(selector);

          if (!newBlock || !currentBlock) return;

          currentBlock.replaceWith(newBlock);
          const mlvPrintSku = document.querySelector(".mlv-print-title-sku span");
          if (selector === '.product__block.product__block--sku' && mlvPrintSku) {
            const skuValue = newBlock
              .querySelector('.product__sku')
              ?.textContent
              .replace('SKU:', '')
              .replace('Style :', '')
              .trim();

            mlvPrintSku.textContent = `,\u00A0Style\u00A0${skuValue}`;
          }

           const stickyAtcBarContainer = document.querySelector("sticky-atc-bar");
          if(stickyAtcBarContainer){
            stickyAtcBarContainer.setObserveTarget(true);
          }


        });

        if(document.querySelector('sticky-atc-bar') && document.querySelector('product-info')){
          document.querySelector('sticky-atc-bar').productForm.innerHTML = document.querySelector('product-info').productForm.innerHTML;
        }

        console.log("Updated product blocks from matching variant:", foundVariantId);
      }

      async updateVariantImage(oldSelectedOptionValues) {
        const activeImage = document.querySelector("media-gallery .mlveda-merge-image motion-element img");
        if (activeImage) {
          // activeImage.src = newBlock.querySelector(".product-form[data-variant-image]").getAttribute("data-variant-image");
          // activeImage.srcset = newBlock.querySelector(".product-form[data-variant-image]").getAttribute("data-variant-image");
          const activeImage = document.querySelectorAll(
            ".mlveda-merge-image img"
          );

          // FIXED FINAL WIDTH of the SHADE (whole lamp width)
          const FINAL_WIDTH = 500;

          // RATIOS based on your real lamp
          const BODY_RATIO = 0.40;
          const BASE_RATIO = 0.40;

          // MOVE ONLY THE BASE UP
          const BASE_UP_OFFSET = -20;  // <--- only base moves upward

          function scaleWidth(img, targetWidth) {
            if (img) {
              const scale = targetWidth / img.width;
              return {
                width: targetWidth,
                height: img.height * scale,
                scale
              };
            }

            return {
              width: targetWidth,
              height: 0,
              scale: 0
            }
          }


          if (activeImage.length > 0) {

            // Load Shopify-selected images
            // const shadeImg  = await loadImage(this.getImageUrlById(oldSelectedOptionValues[1]));
            // const bodyImg   = await loadImage(this.getImageUrlById(oldSelectedOptionValues[2]));
            // const baseImg   = await loadImage(this.getImageUrlById(oldSelectedOptionValues[0]));

            // const shadeImg  = await loadImage(this.getImageUrlById(oldSelectedOptionValues[1]));
            // const bodyImg   = await loadImage(this.getImageUrlById(oldSelectedOptionValues[0]));
            // const baseImg   = await loadImage(this.getImageUrlById(oldSelectedOptionValues[2]));

            let shadeImg = null;
            let bodyImg = null;
            let baseImg = null;
            if (oldSelectedOptionValues.length > 0) {
              for (let index = 0; index < oldSelectedOptionValues.length; index++) {
                const value = oldSelectedOptionValues[index];

                switch (index) {
                  case 0:
                    bodyImg = await loadImage(this.getImageUrlById(value));
                    break;

                  case 1:
                    shadeImg = await loadImage(this.getImageUrlById(value));
                    break;

                  case 2:
                    baseImg = await loadImage(this.getImageUrlById(value));
                    break;
                }
              }
            }


            const RATIO = {
              "FINAL_WIDTH": 520,
              "BODY_RATIO": window.finish_portion,
              "BASE_RATIO": window.base_portion,
              "SHADE_RATIO": window.shade_portion,
              "BASE_UP_OFFSET": -Math.abs(window.base_up_offset)
            }
            this.generateImage(shadeImg, bodyImg, baseImg, activeImage, RATIO);

          }
        } else {
          console.log("Active Image is not found.");
        }
      }


      generateImage(shadeImg, bodyImg, baseImg, activeImage, {
        FINAL_WIDTH = 500,
        BODY_RATIO = 0.60,
        BASE_RATIO = 0.40,
        SHADE_RATIO = 0.90,
        BASE_UP_OFFSET = -20
      } = {}) {
        // SCALE TO CORRECT WIDTHS
        
        const shadeScaled = scaleWidth(shadeImg, FINAL_WIDTH * (SHADE_RATIO / 100));
        const bodyScaled = scaleWidth(bodyImg, FINAL_WIDTH * (BODY_RATIO / 100));
        const baseScaled = scaleWidth(baseImg, FINAL_WIDTH * (BASE_RATIO / 100));

        // CANVAS HEIGHT
        let y = 0;
        let totalHeight =
          shadeScaled.height +
          bodyScaled.height +
          baseScaled.height +
          BASE_UP_OFFSET + 20;

        if (window.overlap_option == "Finish") {
          totalHeight -= bodyScaled.height;
          y = y - bodyScaled.height;
        }

        if (window.overlap_option == "Shade") {
          totalHeight = totalHeight - shadeScaled.height
          y = y - shadeScaled.height;
        }

        const canvas = document.createElement("canvas");
        canvas.width = FINAL_WIDTH + 20;
        canvas.height = totalHeight + 30;

        const ctx = canvas.getContext("2d");



        // if(shadeImg){
        //   ctx.drawImage(
        //     shadeImg,
        //     (FINAL_WIDTH - shadeScaled.width) / 2,
        //     16,
        //     shadeScaled.width,
        //     shadeScaled.height
        //   );
        //   y += shadeScaled.height;
        // }

        // -------- BASE (moved up slightly) --------
        if (baseImg) {
          ctx.drawImage(
            baseImg,
            (FINAL_WIDTH - baseScaled.width) / 2,
            bodyScaled.height + shadeScaled.height + BASE_UP_OFFSET + 30,  // ← only the base moves upward and Starting point of Base
            baseScaled.width,
            baseScaled.height
          );
        }

        // -------- BODY/Finish --------
        if (bodyImg) {
          let bodyImageStart = shadeScaled.height;
          if (window.finish_starting_point) {
            bodyImageStart = Number(window.finish_starting_point)
          }
          ctx.drawImage(
            bodyImg,
            (FINAL_WIDTH - bodyScaled.width) / 2,
            bodyImageStart, // Starting point of Finish
            bodyScaled.width,
            bodyScaled.height + 30
          );
          y += bodyScaled.height;
        }

        // -------- SHADE --------
        if (shadeImg) {
          const shadeImageStart = window.shade_starting_point ?? 0;
          ctx.drawImage(
            shadeImg,
            (FINAL_WIDTH - shadeScaled.width) / 2,
            shadeImageStart,                 // Starting point of Shade
            shadeScaled.width,
            shadeScaled.height
          );
          y += shadeScaled.height;
        }

        // FINAL MERGED IMAGE
        const url = canvas.toDataURL("image/png");
        activeImage.forEach((img, index) => {

          if (img.closest(".product__media-item")) {
            img.closest(".product__media-item").classList.add("swiper-slide-active");
            img.closest(".product__media-item").setAttribute("data-src",url)
          }

          if (index == 0 && this.querySelector('.product__media-gallery').sliderInstance) {
            this.querySelector('.product__media-gallery').sliderInstance.slider.slideToLoop(0);
          }
          img.src = url;
          img.classList.add("active-base64-image", "product-media-image");
          img.srcset = url;
          this.base64Image = url;
          img.dataset.zoom = url;
          img.removeAttribute("height");
          img.removeAttribute("width");
          img.style.display = "block";
          img.style.margin = "0 auto";
          img.style.height = "100%";
        })

                this.updateMedia(this.currentVariant);

      }

      findNextAvailableVariant(currentTarget) {
        console.log("currentTarget: ", currentTarget.closest("fieldset"));

        const currentOptIndex = currentTarget.closest("fieldset")?.getAttribute("data-opt-index");
        const container = this.querySelector("variant-selects");
        if (!container) return;

        // First check if any unavailable variant option is selected or not:
        const unavailableSelectedOpt = container.querySelector("input.disabled.input-opt-disabled:checked");
        if (unavailableSelectedOpt) {
          const targetFieldSet = unavailableSelectedOpt.closest("fieldset");
          if (targetFieldSet) {
            const newAvailableInput = targetFieldSet.querySelector("input.input-opt-enabled");
            if (newAvailableInput) {
              console.log("unavailableSelectedOpt found: ", newAvailableInput.value);
              newAvailableInput.checked = true;
              newAvailableInput.dispatchEvent(
                new Event("change", {
                  bubbles: true,
                  composed: true
                })
              );
              return;
            }
          }
        }

        const allFieldsets = Array.from(container.querySelectorAll("fieldset")).reverse();

        const clickedFieldset = currentTarget.closest("fieldset");
        if (!clickedFieldset) return;

        // const clickedIndex = allFieldsets.indexOf(clickedFieldset);

        // safety check
        // if (clickedIndex === -1) return;

        // create list excluding the clicked fieldset by index
        const fieldsets = allFieldsets.filter((_, index) => index != Number(currentOptIndex));
        console.log(fieldsets)


        // helper: find first enabled input inside a fieldset
        const findEnabledInput = (fieldset) =>
          fieldset.querySelector("input:not(.disabled):not([disabled]):not(:checked)");

        // try to find next available input from subsequent fieldsets
        let nextInput = null;

        for (const fs of fieldsets) {
          nextInput = findEnabledInput(fs);
          if (nextInput) break;
        }

        // fallback: wrap around and search again
        if (!nextInput) {
          for (const fs of fieldsets) {
            nextInput = findEnabledInput(fs);
            if (nextInput) break;
          }
        }

        // select & trigger change
        if (nextInput) {
          console.log("next: ", nextInput);
          nextInput.checked = true;
          nextInput.dispatchEvent(
            new Event("change", {
              bubbles: true,
              composed: true
            })
          );
        }


      }


      handleUpdateProductInfo(productUrl, viewMode, selectedOptionValues, currentTarget) {
        return async (html) => {
          const quickView = html.querySelector('#MainProduct-quick-view__content');
          if (quickView && viewMode === 'quick-view') {
            html = quickView.content.cloneNode(true);
          }
          const variant = this.getSelectedVariant(html, selectedOptionValues);

          // if(variant || !this.additionalProductFound){
          if (variant || !this.additionalProductFound) {
            this.pickupAvailability?.update(variant);
            this.updateOptionValues(html);
            this.updateVariantRelatedInfo(html);
            this.updateURL(productUrl, variant?.id);
            this.updateShareUrl(variant?.id);
            this.updateVariantInputs(variant?.id);
            this.updateAddToCartButton(html);
          }

          // option recommendation 
          this.updateRecommendationOption();

           if(!variant?.available){
             const stickyAtcBarWrapper = document.querySelector('#shopify-section-sticky-atc-bar');
            if (stickyAtcBarWrapper) {
              stickyAtcBarWrapper.classList.add('hidden');
            }
          }

          // if (!variant) {
          //   this.setUnavailable();
          //   return;
          // }
          //  this.updateVariantImage(selectedOptionValues);
          // const additionalProductFound = this.getAttribute("data-merge-product")
          if (!this.additionalProductFound && !variant) {
            // this.setUnavailable();
            console.log("this.additionalProductFound: ", this.additionalProductFound);
            setTimeout(() => {
              this.findNextAvailableVariant(currentTarget);
            }, 1000);

            // Find next available variant:
            return;
          }
          if (!variant) {
            const productData = await this.checkForRelatedProducts(selectedOptionValues);
            //   this.renderProductInfo({
            //   requestUrl: this.buildRequestUrlWithParams(`/products/${productHandle}`, selectedOptionValues, shouldFetchFullPage),
            //   targetId: target.id,
            //   callback: shouldSwapProduct
            //     ? this.handleSwapProduct(productUrl, shouldFetchFullPage, viewMode, selectedOptionValues)
            //     : this.handleUpdateProductInfo(productUrl, viewMode, selectedOptionValues),
            // });
          
            if (!productData) {
            
              this.setUnavailable();
              document.querySelector(".mlv-print-title-sku span")?.classList.add("mlv-is-display-none");
         
              return;
            } else {
              
              document.querySelector(".mlv-print-title-sku span")?.classList.remove("mlv-is-display-none");
              // const updateBuyButtonsNew = await this.updateBuyButtons(productData.handle, productData.values, selectedOptionValues);
              const updateBuyButtonsNew = await this.updateBuyButtons(productData, currentTarget);
              return;
            }
          }

          this.updateMedia(variant);
          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
              document.querySelector(".mlv-print-title-sku span")?.classList.remove("mlv-is-display-none");
            }

            const mlvPrintSku = document.querySelector(".mlv-print-title-sku span");
            if (id === 'Sku' && mlvPrintSku) {
              const skuValue = source
                .querySelector('.product__sku')
                ?.textContent
                .replace('SKU:', '')
                .replace('Style :', '')
                .trim();

              mlvPrintSku.textContent = `,\u00A0Style\u00A0${skuValue}`;
            }

          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku');
          updateSourceFromDestination('Inventory');
          updateSourceFromDestination('Badges');
          updateSourceFromDestination('PricePerItem');
          updateSourceFromDestination('Volume');

          this.updateQuantityRules(this.sectionId, this.productId, html);
          updateSourceFromDestination('QuantityRules');
          updateSourceFromDestination('VolumeNote');

          HTMLUpdateUtility.viewTransition(
            document.querySelector(`#SizeChart-${this.sectionId}`),
            html.querySelector(`#SizeChart-${this.sectionId}`),
            this.preProcessHtmlCallbacks,
            this.postProcessHtmlCallbacks
          );

          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
          this.toggleAddButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
            FoxTheme.variantStrings.soldOut
          );

          const stickyAtcBar = document.getElementById(`shopify-section-sticky-atc-bar`);
          if (stickyAtcBar) {
            stickyAtcBar.classList.remove('hidden');
          }

          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });

          document.dispatchEvent(
            new CustomEvent('variant:changed', {
              detail: {
                variant: variant,
              },
            })
          );

          this.enableButtons();
        };
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues && optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      // getSelectedVariant(productInfoNode, selectedOptionValues=[]) {
      //   const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
      //   if(selectedOptionValues.length > 0){
      //     const parsedHTML = JSON.parse(selectedVariant);
      //     let allMatched = true;
      //     selectedOptionValues.forEach((element,index) => {
      //       const optvalue = this.querySelector(`input[data-option-value-id="${element}"]`)?.value;
      //       if(optvalue != parsedHTML.options[index]){
      //         return null;
      //       }
      //     });
      //     return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      //   }
      //   return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      // }

      // Find selected Variant
      getSelectedVariant(productInfoNode, selectedOptionValues = []) {
        const selectedVariantHTML = productInfoNode
          .querySelector('variant-selects [data-selected-variant]')
          ?.innerHTML;

        if (!selectedVariantHTML) return null;

        const parsedHTML = JSON.parse(selectedVariantHTML);

        if (selectedOptionValues.length > 0) {
          let variantFound = true;
          for (let index = 0; index < selectedOptionValues.length; index++) {
            const element = selectedOptionValues[index];
            const opt = this.querySelector(
              `input[data-option-value-id="${element}"]`
            )
            const optvalue = opt?.value;

            if (parsedHTML == null || optvalue !== parsedHTML.options[index]) {
              if (opt) {
                const spanElement = opt.closest("fieldset").querySelector("legend span[data-selected-swatch-value]")
                if (spanElement) {
                  spanElement.textContent = optvalue;
                }
              }
              if (variantFound) {
                variantFound = false;
              }
            }
          }
          if (!variantFound) {
            return null; // now this actually returns from the function
          }
        }

        return parsedHTML;
      }


      // Update product information
      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }


      // Update variant related information like description, material and care etc
      updateVariantRelatedInfo(html) {
        const collapsibleTabs = html.querySelector(".product__block--metafield_collapsible_tab");
        const oldCollapsibleTabs = this.querySelector(".product__block--metafield_collapsible_tab")
        if (collapsibleTabs && oldCollapsibleTabs) {
          oldCollapsibleTabs.innerHTML = collapsibleTabs.innerHTML;
        }
        const mlvPrintVariantData = document.querySelector(".mlv-print-metafields");

        if (mlvPrintVariantData && collapsibleTabs) {
          mlvPrintVariantData.innerHTML = collapsibleTabs.querySelector(".accordion-details__content").innerHTML;
        }

        const oldDescription = document.querySelector(".product__variant-description");
        const newDescription = html.querySelector(".product__variant-description");

        if(newDescription){
          oldDescription.innerHTML = newDescription.innerHTML;
        }else{
          if(oldDescription){
            oldDescription.innerHTML = null;
          }
        }
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      updateURL(url, variantId) {
        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      updateVariantInputs(variantId) {
        document
          .querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`)
          .forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = variantId ?? '';
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
      }

      updateMedia(variant) {

        const productMedia = this.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
        if (!productMedia) return; // Early return if productMedia is not found

        const setActiveMedia = () => {
          if (typeof productMedia.setActiveMedia === 'function') {
            productMedia.init();
            productMedia.setActiveMedia(variant);
            return true; // Indicate success
          }
          return false; // Indicate failure
        };

        if (!setActiveMedia()) {
          this.timer = setInterval(() => {
            if (setActiveMedia()) {
              clearInterval(this.timer);
            }
          }, 100);
        }

        const printImageVariant = document.querySelector(
          '.mlv-product-images-grid-print .product-image-item.variant'
        );
        const printImageproduct = document.querySelector(
          '.mlv-product-images-grid-print .product-image-item.product'
        );
        const printImageVariantBase64 = document.querySelector(
          '.mlv-product-images-grid-print .product-image-item.variant-base64'
        );
        const mlvStickyAddToCart = document.querySelector(
          '.sticky-atc-bar__product-image'
        );

        const diffImage = document.querySelector(".mlveda-merge-image");
        const diffImgEl = diffImage?.querySelector("img");

        const isPlaceholder =
          diffImgEl &&
          diffImgEl.src.includes("Image-placeholder");

        if (diffImage && diffImgEl && !isPlaceholder) {
          // ✅ REAL merged image → show base64 image
          printImageVariantBase64.classList.add("mlv-is-visible-block");
          printImageVariant.classList.remove("mlv-is-visible-block");
          printImageproduct.classList.remove("mlv-is-visible-block");

          printImageVariantBase64.innerHTML = diffImage.innerHTML;

          if(mlvStickyAddToCart){
            mlvStickyAddToCart.innerHTML = diffImage.innerHTML;
          }

        } else {
          // ❌ Placeholder OR no merged image → fallback
          printImageVariantBase64.classList.remove("mlv-is-visible-block");

          if (!variant?.featured_media?.preview_image?.src) {
            // 👉 No variant image → show product image
            printImageproduct.classList.add("mlv-is-visible-block");
            printImageVariant.classList.remove("mlv-is-visible-block");

            if(mlvStickyAddToCart){
              mlvStickyAddToCart.innerHTML = printImageproduct.innerHTML;
            }

          } else {
            // 👉 Variant image exists
            printImageproduct.classList.remove("mlv-is-visible-block");
            printImageVariant.classList.add("mlv-is-visible-block");

            const printImageVariantImage =
              printImageVariant.querySelector("img");

            if (printImageVariantImage) {
              const newSrc = variant.featured_media.preview_image.src;

              printImageVariantImage.src = newSrc;
              printImageVariantImage.srcset = "";
              printImageVariantImage.loading = "eager";

              // Force repaint (important for print)
              printImageVariantImage.style.display = "none";
              requestAnimationFrame(() => {
                printImageVariantImage.style.display = "";
              });
            }

            const mlvStickyAddToCartImage =
              mlvStickyAddToCart.querySelector("img");

            if (mlvStickyAddToCartImage) {
              const newSrc = variant.featured_media.preview_image.src;

              mlvStickyAddToCartImage.src = newSrc;
              mlvStickyAddToCartImage.srcset = "";
              mlvStickyAddToCartImage.loading = "eager";

              // Force repaint (important for print)
              mlvStickyAddToCartImage.style.display = "none";
              requestAnimationFrame(() => {
                mlvStickyAddToCartImage.style.display = "";
              });
            }

            
          }
        }

      }

      updateShareUrl(variantId) {
        if (!variantId) return;
        const shareButton = document.getElementById(`ProductShare-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${variantId}`);
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = this.decoded(text);
          // Added by MLVeda : Start
          addButton.classList.add('mlv-sold-out');
          addButton.closest(".product-form__buttons").querySelector(".shopify-payment-button__button")?.classList.add('mlv-sold-out-buy-now');
          // Added by MLVeda : End
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = this.decoded(FoxTheme.variantStrings.addToCart);
          // Added by MLVeda : Start
          addButton.classList.remove('mlv-sold-out');
          addButton.closest(".product-form__buttons").querySelector(".shopify-payment-button__button")?.classList.remove('mlv-sold-out-buy-now');
          // Added by MLVeda : End
        }

        if (!modifyClass) return;
      }

      decoded(text) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = text;
        const decoded = tempDiv.textContent;
        return decoded;
      }

      setUnavailable() {
        this.toggleAddButton(true, FoxTheme.variantStrings.unavailable);
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);
        const volumePricing = document.getElementById(`Volume-${this.dataset.section}`);
        const stickyAtcBar = document.getElementById(`shopify-section-sticky-atc-bar`);

        if (price) price.classList.add('hidden');
        if (inventory) inventory.classList.add('hidden');
        if (sku) sku.classList.add('hidden');
        if (volumePricing) volumePricing.classList.add('hidden');
        if (stickyAtcBar) stickyAtcBar.classList.add('hidden');
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.setQuantityBoundries();
        if (!this.hasAttribute('data-original-section')) {
          this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      setQuantityBoundries() {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityBoundries, {
          data: {
            sectionId: this.sectionId,
            productId: this.productId,
          },
        });
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.productIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart')?.classList.add('btn--loading');

        fetch(`${this.getAttribute('data-url')}?variant=${currentVariantId}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.sectionId, this.productId, parsedHTML);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart')?.classList.remove('btn--loading');
          });
      }

      updateQuantityRules(sectionId, productId, parsedHTML) {
        if (!this.quantityInput) return;

        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityRules, {
          data: {
            sectionId,
            productId,
            parsedHTML,
          },
        });

        this.setQuantityBoundries();
      }

      disableButtons() {
        this.toggleButtons(true);
      }

      enableButtons() {
        this.toggleButtons(false);
      }

      toggleButtons(disabled) {
        const buttonSelectors = [
          '[name="add"]',
          '.shopify-payment-button__button',
          '.sticky-atc-bar [name="add"]'
        ];

        buttonSelectors.forEach(selector => {
          const buttons = document.querySelectorAll(selector);
          buttons.forEach(button => {
            if (disabled) {
              button.setAttribute('disabled', 'disabled');
              button.style.pointerEvents = 'none';
              button.style.opacity = '0.6';
            } else {
              if (selector === '[name="add"]') {
                const variantId = button.closest('form')?.querySelector('[name="id"]')?.value;
                if (!variantId) return;
              }

              button.removeAttribute('disabled');
              button.style.pointerEvents = '';
              button.style.opacity = '';
            }
          });
        });
      }

      updateRecommendationOption(){

        const selectedInputs = this.querySelectorAll(`input[type="radio"]:checked`);
        let scriptData = this.querySelector("script#option-mapping-json");

        if(selectedInputs.length > 0 && scriptData){
          let productTitle = scriptData.dataset.product;
          const targetedInput = [...selectedInputs].find((input)=> input.dataset.optionName == "Middle" || input.dataset.optionName == "Body");
          let finishOption = targetedInput ?? selectedInputs[0];
          let finishOptionValue = finishOption.value;
          let optionMappingText = scriptData.textContent.trim();

          // Get the all option mapping
          const optionMappingObject = JSON.parse(optionMappingText);
          // Find the current product options mapping
          const productOptMapping = optionMappingObject[productTitle];
          let selectedOptSuggestions = null;

          // Find fist selected option suggestions in specific product
          if(productOptMapping){
            selectedOptSuggestions = productOptMapping[finishOptionValue];
          }

          // If option value not found in specific product then check in global mapping
          if(!selectedOptSuggestions){
            selectedOptSuggestions = optionMappingObject[finishOptionValue];
          }

          // Still you dont find the option then remove the existing selection and return

          // Remove previous selection
            const preSuggestion = this.querySelectorAll(".finish-suggestion");
              if(preSuggestion.length > 0){
                preSuggestion.forEach(sug => {
                  // Remove the class
                  sug.classList.remove("finish-suggestion");
                  // update tooltip
                  // const suggestionElementLabel = this.querySelector(`input[value="${sug}"] + label .tooltip`)
                  // if(suggestionElementLabel){
                  //   suggestionElementLabel.textContent = `${suggestionElementLabel.textContent.split(" (")[0]}`;
                  // }
              });
            }

          
          if(selectedOptSuggestions && Array.isArray(selectedOptSuggestions) && selectedOptSuggestions.length > 0){
            // Add New selection
            selectedOptSuggestions.forEach(sug => {
              const suggestionElement = this.querySelector(`input[value="${sug.trim()}"]`);
              if(suggestionElement){
                suggestionElement.classList.add("finish-suggestion");
              }
              // const suggestionElementLabel = this.querySelector(`input[value="${sug.trim()}"] + label .tooltip`)
              // if(suggestionElementLabel){
              //   suggestionElementLabel.textContent = `${suggestionElementLabel.textContent.split(" (")[0]} (Pairs well with ${finishOptionValue})`;
              // }
            });
          }else{
            return;
          }
          
        }
        
      }
    }
  );
}
